<template>
    <div class="has-text-centered">
        <div class="app-block  p-md">
            <div>
                <p><strong>Vous souhaitez payer par prélèvement bancaire</strong></p>
            </div>
            <br>
            <div>
                Veuillez sélectionner une date pour votre premier prélèvement
                <br>
                <div class="p-md m-l-lg">
                    <div class="columns ">
                        <div class="column is-offset-5 is-4">
                            <b-select v-model="firstPayment" @change="paymentCheckStub"
                                      v-validate="'required'" name="series">
                                <option disabled value="">Choix de la date</option>
                                <option
                                        v-for="(date, index) in dates"
                                        :value="date"
                                        :key="index">
                                    {{ date }}
                                </option>
                            </b-select>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <div>
                Veuillez sélectionner le nombre de prélèvements que vous souhaitez
            </div>
            <br>


            <div :class="[!firstPayment ? 'app-disabled':'']">
                <div class="columns ">
                    <div class="column is-offset-3 is-3">
                        <b-field :class="'radio-check' [firstPayment ? 'app-disabled':'']">

                            <b-radio-button v-for="(check, index) in checkStubs()" v-model="checkNumber"
                                            @input="paymentCheckStub"
                                            :native-value="check"
                                            :key="index">
                                <span>{{ check }}</span>
                            </b-radio-button>

                        </b-field>
                    </div>
                </div>
            </div>


            <hr>
            <div class="has-text-centered" v-if="checkNumber !== 0">

                <br>
                <div class="p-md" v-if="paymentCheckStubs.length > 0">
                    <div class="table-responsive">
                        <table class="table is-striped is-narrow is-fullwidth is-bordered">
                            <thead>
                            <tr>
                                <th></th>
                                <th>Date</th>
                                <th>Montant</th>
                            </tr>
                            </thead>

                            <tfoot v-if="checkNumber > 1">
                            <tr>
                                <th>Total</th>
                                <th colspan="2" class="has-text-centered">{{ totalCheckout }} {{ school.fees_currency }}
                                </th>
                            </tr>
                            </tfoot>

                            <tbody>
                            <tr v-for="(payment, index) in paymentCheckStubs">
                                <td>
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ formatDate(payment.date) }}
                                </td>
                                <td>
                                    {{ payment.amount }} {{ school.fees_currency }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div v-if="checkNumber !== 0">
                <transition name="slide-fade">
                    <div class="has-text-danger">{{ errorMsg }}</div>
                </transition>
                <hr>
                <button :class="'button button-save ' + isLoading" @click="send">Je souhaite régler en {{ checkNumber }}
                    fois
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import api from 'services/organization'
    import moment from 'moment/moment'

    export default {
        data () {
            return {
                isLoading: '',
                errorMsg: '',
                checkNumber: 0,
                firstPayment: null,
                currentPayment: null,
                dates: {},
                minDate: null,
                maxDate: null,
                paymentCheckStubs: [],
                orderTotal: 0,
                trainingFees: 0,
                monthInterval: 0,
            }
        },
        computed: {
            ...mapGetters({
                status: 'orders/status'
            }),
            ...mapGetters(
                'orders', [
                    'orderRef',
                    'cartChoices',
                    'selectedOrder'
                ]
            ),
            ...mapGetters('organization', [
                'currentScholarYear'
            ]),
            application () {
                return this.candidate.applications
            },
        },
        watch: {
            choices: function () {
                this.paymentCheckStub()
            }
        },
        props: {
            school: { type: Object },
            candidate: { type: Object },
            totalCheckout: { type: Number },
            guarantor: { type: Number },
            credit: { type: Number },
            discount: { type: Array },
        },
        methods: {
            ...mapActions(
                'orders', [
                    'orderCheckout'
                ]
            ),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            formatDate (date) {
                return moment(date, 'DD-MM-YYYY').format('LL')
            },
            checkStubs () {
                const firstDate = window.moment(this.firstPayment, 'DD-MM-YYYY')
                const training = this.application.choices[ 0 ].training
                const endDate = training.end.split('/')
                const year = this.application.choices[ 0 ].scholar_year.split('/')
                const endTraining = moment().year(year[ 1 ]).month(endDate[ 1 ]).date(endDate[ 0 ])
                const monthNumber = Math.abs(firstDate.diff(moment(endTraining), 'months', true))

                if (monthNumber < 8) {
                    return [ 1, 2, 3, 4, 5, 6, 7 ]
                }
                if (monthNumber < 10) {
                    return [ 1, 2, 3, 4, 5, 6, 7, 8 ]
                }
                else {
                    return [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ]
                }

            },

            paymentCheckStub () {
                this.errorMsg = ''
                if (this.firstPayment === null || !this.totalCheckout) {
                    /*this.errorMsg = 'Veuillez sélectionner une date pour votre premier paiement'*/
                    return
                }

                const checks = this.checkStubs()
                if (this.checkNumber !== 0 && !checks.includes(this.checkNumber)) {
                    this.checkNumber = checks[ checks.length - 1 ]
                }

                this.paymentCheckStubs = []
                this.orderTotal = 0
                const training = this.application.choices[ 0 ].training


                const checkFee = Math.ceil(this.totalCheckout / this.checkNumber)

                const firstDate = window.moment(this.firstPayment, 'DD-MM-YYYY')

                const endDate = training.end.split('/')

                const year = this.application.choices[ 0 ].scholar_year.split('/')
                const endTraining = moment().year(year[ 1 ]).month(endDate[ 1 ]).date(endDate[ 0 ])

                let monthNumber = moment(endTraining).diff(firstDate, 'months', true)

                let monthInterval = Math.round(monthNumber / this.checkNumber)

                this.paymentCheckStubs.push({ 'date': firstDate.format('DD-MM-YYYY'), 'amount': checkFee, 'number': 1 })
                this.orderTotal = checkFee

                if (this.checkNumber > 1) {
                    for (let j = 0; j < this.checkNumber - 2; j++) {
                        this.orderTotal += checkFee

                        if (firstDate.month() >= 7) {
                            monthInterval = 1
                        }
                        this.paymentCheckStubs.push({
                            'date': firstDate.add(monthInterval, 'month').format('DD-MM-YYYY'),
                            'amount': checkFee,
                            'number': j + 2
                        })
                    }
                    this.orderTotal += checkFee
                    const lastFee = checkFee - (this.orderTotal - this.totalCheckout)
                    if (this.checkNumber === 2) {
                        if (firstDate.month() === 7) {
                            this.paymentCheckStubs.push({
                                'date': firstDate.month('10').format('DD-MM-YYYY'),
                                'amount': lastFee,
                                'number': 2
                            })
                        } else {
                            this.paymentCheckStubs.push({
                                'date': firstDate.month('7').format('DD-MM-YYYY'),
                                'amount': lastFee,
                                'number': 2
                            })
                        }
                    } else {
                        this.paymentCheckStubs.push({
                            'date': firstDate.add(monthInterval, 'month').format('DD-MM-YYYY'),
                            'amount': lastFee,
                            'number': this.checkNumber
                        })
                    }

                }
            },
            send: function () {
                this.toggleLoading()
                const order = {}
                order.id = this.selectedOrder ? this.selectedOrder.id:this.orderRef
                order.cart = this.cartChoices
                order.guarantor = this.guarantor
                order.order_date = new Date()
                order.payment_mode = 'BANK-DEBIT'
                order.credit = this.credit
                order.discount = this.discount
                order.payment_total = this.totalCheckout
                order.payment_currency = this.school.fees_currency
                order.payment_number = this.checkNumber
                order.payments = this.paymentCheckStubs
                order.school = this.$route.params.school
                this.orderCheckout(order).then((result) => {
                    if (this.status === 200) {
                        this.toggleLoading()
                        this.$emit('send')
                    } else if (this.status === 403) {
                        this.toggleLoading()
                        this.$emit('notAuthenticated')
                    } else {
                        this.toggleLoading()
                        this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                    }
                }).catch(() => {
                    this.toggleLoading()
                    this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                })
            }
        },
        created () {
            /*
            TODO Problème this.application vient du candidates[0], qui n'a pas forcément de schooling associé,
            il faut ajouter un getter vuex pour récupérer le premier schooling pour l'année scolaire en cours afin de déterminer
            les dates d'ofp à afficher, 25/08 si schooling de l'année en cours sinon la liste
             */
            if (this.currentScholarYear === this.application.choices[ 0 ].scholar_year) {
                api.setting('ofp_date').then((result) => {
                    let dates = JSON.parse(result.data.value)
                    this.dates = dates['current_year']
                }).catch((err) => {
                })

            }else{
                api.setting('ofp_date').then((result) => {
                    let dates = JSON.parse(result.data.value)
                    this.dates = dates['next_year']
                }).catch((err) => {
                })
            }
        }
    }
</script>

<style scoped>
    .field.has-addons .control:not(:last-child) {
        margin-right: 18px;
    }
</style>
